// src/components/contact-us/contact-us-form.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ContactUsToolBarFragment on ContactUsToolBar {\n    title\n    icon {\n      id\n    }\n    navIconLabel\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    spotLight\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    icon {\n      ...EGDSIconFragment\n    }\n    accessibility\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextInputFragment on EGDSInputField {\n    label\n    readOnly\n    required\n    leftIcon {\n      ...EGDSIconFragment\n    }\n    rightIcon {\n      ...EGDSIconFragment\n    }\n    validations {\n      errorMessage\n      ... on EGDSRegexInputValidation {\n        pattern\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextAreaInputFragment on EGDSTextAreaInputField {\n    label\n    readOnly\n    required\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment ContactUsSendEmailFailedFragment on ContactUsSendEmailFailed {\n    title\n    message\n    icon {\n      id\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment ContactUsSendEmailSuccessFragment on ContactUsSendEmailSuccess {\n    title\n    message\n    icon {\n      id\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  mutation sendContactUsEmail(\n    $context: ContextInput!\n    $customerName: String!\n    $customerEmail: String!\n    $details: String!\n    $intent: String!\n    $product: String!\n  ) {\n    contactUsOptions(context: $context) {\n      sendContactUsEmail(\n        sendEmailRequest: { customerName: $customerName, customerEmail: $customerEmail, details: $details, intent: $intent, product: $product }\n      ) {\n        ...ContactUsSendEmailSuccessFragment\n        ...ContactUsSendEmailFailedFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  query EmailUsForm($context: ContextInput!) {\n    contactUsOptions(context: $context) {\n      contactUsEmailFormView(optionType: SEND_EMAIL_AGENT) {\n        ... on ContactUsEmailSheet {\n          back\n          toolBar {\n            ...ContactUsToolBarFragment\n          }\n          customerName {\n            ...EGDSTextInputFragment\n          }\n          customerEmail {\n            ...EGDSTextInputFragment\n          }\n          heading\n          subheading\n          details {\n            ...EGDSTextAreaInputFragment\n          }\n          send {\n            ...EGDSButtonFragment\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment ContactUsErrorViewFragment on ContactUsErrorView {\n    heading\n    subHeadingText: subheading\n    icon {\n      id\n    }\n    errorTitle\n    errorMessage\n    toolBar {\n      ...ContactUsToolBarFragment\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment ContactUsOptionFragment on ContactUsOption {\n    optionLabel\n    leftIcon {\n      id\n    }\n    rightIcon {\n      id\n    }\n    waitTime\n    option\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  query ContactUsOptions($context: ContextInput!, $phoneNumber: String!, $itineraryNumber: String!, $category: String!, $intent: String!) {\n    contactUsOptions(context: $context) {\n      contactUsOptionsView(searchFormInput: { phoneNumber: $phoneNumber, itineraryNumber: $itineraryNumber, category: $category, intent: $intent }) {\n        ... on ContactOptionsSheet {\n          heading\n          subheading\n          options {\n            ...ContactUsOptionFragment\n          }\n          toolBar {\n            ...ContactUsToolBarFragment\n          }\n        }\n        ...ContactUsErrorViewFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicOptionFragment on EGDSBasicOption {\n    value\n    selected\n    label\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSelectFragment on EGDSBasicSelect {\n    options {\n      ...EGDSBasicOptionFragment\n    }\n    label\n    egdsElementId\n    readOnly\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  query ContactUsFormDetails($context: ContextInput!, $articleProduct: String, $articleIntent: String) {\n    contactUsOptions(context: $context) {\n      contactUsSheetViewWithPayload(articleProduct: $articleProduct, articleIntent: $articleIntent) {\n        ... on ContactUsSheet {\n          toolBar {\n            ...ContactUsToolBarFragment\n          }\n          heading\n          subheading\n          customerFormContent {\n            phoneNumber {\n              ...EGDSTextInputFragment\n            }\n            itineraryNumber {\n              ...EGDSTextInputFragment\n            }\n            categorySelect {\n              ...EGDSSelectFragment\n            }\n            intentSelect {\n              ...EGDSSelectFragment\n            }\n          }\n          seeContactUsOptions {\n            ...EGDSButtonFragment\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment PhoneNumberDataFragment on PhoneNumberData {\n    call {\n      ...EGDSButtonFragment\n    }\n    region\n    phoneType\n    phoneNumber\n  }\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  query SpeakNextAvailableAgentView($context: ContextInput!, $category: String!, $intent: String!) {\n    contactUsOptions(context: $context) {\n      speakNextAvailableAgentSheetView(speakNextAvailableSheetRequest: { category: $category, intent: $intent, optionType: CALL_TO_AGENT }) {\n        ... on SpeakNextAvailableAgentSheet {\n          back\n          toolBar {\n            ...ContactUsToolBarFragment\n          }\n          heading\n          subheading\n          phoneNumberList {\n            ...PhoneNumberDataFragment\n          }\n        }\n        ...ContactUsErrorViewFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
import React23, { useCallback as useCallback3, useState as useState4 } from "react";
// ../internal/src/components/view/sheet-view-port.tsx
import React from "react";
import { EGDSSheet } from "@egds/react-core/sheet";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var SheetViewPort = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /* @__PURE__ */ React.createElement(Viewport, null, /* @__PURE__ */ React.createElement(ViewSmall, null, /* @__PURE__ */ React.createElement(EGDSSheet, _object_spread_props(_object_spread({}, props), {
        type: "full"
    }), children)), /* @__PURE__ */ React.createElement(ViewLarge, null, /* @__PURE__ */ React.createElement(EGDSSheet, _object_spread_props(_object_spread({}, props), {
        type: "centered"
    }), children)));
};
// src/components/contact-us/__private/__fragments/contact-us-email-us-form-view.tsx
import React14, { useState as useState2 } from "react";
import { gql as gql10, useQuery } from "@apollo/client";
import { EGDSForm } from "@egds/react-core/form";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing5, EGDSSpacingHr } from "@egds/react-core/spacing";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
// ../internal/src/components/contact-us-tool-bar/contact-us-tool-bar.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { EGDSToolbar } from "@egds/react-core/toolbar";
var fragment = gql(_templateObject());
var ContactUsToolBar = function(props) {
    var close = props.close, data = props.data;
    var _data_navIconLabel;
    return /* @__PURE__ */ React2.createElement(EGDSToolbar, {
        navigationContent: {
            onClick: close,
            navIconLabel: (_data_navIconLabel = data.navIconLabel) !== null && _data_navIconLabel !== void 0 ? _data_navIconLabel : void 0,
            navButtonId: data.icon.id
        },
        toolbarTitle: data.title
    });
};
ContactUsToolBar.fragment = fragment;
ContactUsToolBar.displayName = "ContactUsToolBar";
// ../internal/src/components/egds-button/egds-button.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var __EGDSIconFragment = gql2(_templateObject1());
var mapSpotlight = function(spotlight) {
    if (!spotlight) {
        return void 0;
    }
    switch(spotlight){
        case "STANDARD" /* STANDARD */ :
            return "standard";
        case "POSITIVE" /* POSITIVE */ :
            return "positive";
        case "WARNING" /* WARNING */ :
            return "warning";
        case "INFO" /* INFO */ :
            return "info";
        default:
            return void 0;
    }
};
var HelpCenterEGDSIcon = function(param) {
    var data = param.data, size = param.size;
    var iconName = data ? data.id : "";
    var finalSize = size !== null && size !== void 0 ? size : (data === null || data === void 0 ? void 0 : data.size) && EGDSIconSize[data.size];
    var spotlight = data === null || data === void 0 ? void 0 : data.spotLight;
    var _data_theme;
    return /* @__PURE__ */ React3.createElement(EGDSIcon, {
        name: iconName,
        size: finalSize,
        theme: (_data_theme = data === null || data === void 0 ? void 0 : data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        spotlight: mapSpotlight(spotlight)
    });
};
HelpCenterEGDSIcon.displayName = "HelpCenterEGDSIcon";
HelpCenterEGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React4 from "react";
import { gql as gql3 } from "@apollo/client";
var __EGDSGraphicFragment = gql3(_templateObject2(), HelpCenterEGDSIcon.fragment);
var EGDSGraphic = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React4.createElement(HelpCenterEGDSIcon, {
                data: data
            });
        default:
            return null;
    }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/egds-button/egds-button.tsx
var __fragment = gql4(_templateObject3(), HelpCenterEGDSIcon.fragment);
var HelpCenterEGDSButton = function(_param) {
    var data = _param.data, onClickHandler = _param.onClickHandler, isDisabled = _param.isDisabled, type = _param.type, _param_iconPosition = _param.iconPosition, iconPosition = _param_iconPosition === void 0 ? "LEADING" /* LEADING */  : _param_iconPosition, otherProps = _object_without_properties(_param, [
        "data",
        "onClickHandler",
        "isDisabled",
        "type",
        "iconPosition"
    ]);
    var primary = data.primary, disabled = data.disabled, accessibility = data.accessibility, __typename = data.__typename, icon = data.icon;
    var buttonProps = {
        disabled: disabled || isDisabled,
        title: accessibility,
        type: type,
        onClick: onClickHandler
    };
    switch(__typename){
        case "UIPrimaryButton":
            return /* @__PURE__ */ React5.createElement(EGDSPrimaryButton, _object_spread({}, buttonProps, otherProps), icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React5.createElement(HelpCenterEGDSIcon, {
                data: icon
            }), primary, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React5.createElement(HelpCenterEGDSIcon, {
                data: icon
            }));
        case "UISecondaryButton":
            return /* @__PURE__ */ React5.createElement(EGDSSecondaryButton, _object_spread({}, buttonProps, otherProps), icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React5.createElement(HelpCenterEGDSIcon, {
                data: icon
            }), primary, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React5.createElement(HelpCenterEGDSIcon, {
                data: icon
            }));
        case "UITertiaryButton":
            return /* @__PURE__ */ React5.createElement(EGDSTertiaryButton, _object_spread({}, buttonProps, otherProps), icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React5.createElement(HelpCenterEGDSIcon, {
                data: icon
            }), primary, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React5.createElement(HelpCenterEGDSIcon, {
                data: icon
            }));
        default:
            return null;
    }
};
HelpCenterEGDSButton.displayName = "HelpCenterEGDSButton";
HelpCenterEGDSButton.fragment = __fragment;
// ../internal/src/components/egds-text-input/egds-text-input.tsx
import React6 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSEmailInput, EGDSTextInput } from "@egds/react-core/input";
var fragment2 = gql5(_templateObject4(), HelpCenterEGDSIcon.fragment);
var HelpCenterEGDSTextInput = function(_param) {
    var data = _param.data, value = _param.value, onChange = _param.onChange, invalid = _param.invalid, pattern = _param.pattern, disabled = _param.disabled, onKeyPress = _param.onKeyPress, otherProps = _object_without_properties(_param, [
        "data",
        "value",
        "onChange",
        "invalid",
        "pattern",
        "disabled",
        "onKeyPress"
    ]);
    var label = data.label, readOnly = data.readOnly, required = data.required;
    switch(data.__typename){
        case "EGDSTextInputField":
            return /* @__PURE__ */ React6.createElement(EGDSTextInput, _object_spread_props(_object_spread({}, otherProps), {
                label: label !== null && label !== void 0 ? label : "",
                readOnly: disabled || readOnly,
                required: required !== null && required !== void 0 ? required : false,
                value: value,
                onChange: onChange,
                invalid: invalid,
                pattern: pattern,
                onKeyPress: onKeyPress
            }));
        case "EGDSEmailInputField":
            return /* @__PURE__ */ React6.createElement(EGDSEmailInput, _object_spread_props(_object_spread({}, otherProps), {
                label: label !== null && label !== void 0 ? label : "",
                readOnly: disabled || readOnly,
                required: required !== null && required !== void 0 ? required : false,
                value: value,
                onChange: onChange,
                invalid: invalid,
                pattern: pattern,
                onKeyPress: onKeyPress
            }));
        default:
            return null;
    }
};
HelpCenterEGDSTextInput.fragment = fragment2;
HelpCenterEGDSTextInput.displayName = "HelpCenterEGDSTextInput";
// ../internal/src/components/egds-text-input/egds-text-area-input.tsx
import React7 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSTextArea } from "@egds/react-core/input";
var fragment3 = gql6(_templateObject5());
var EGDSTextAreaInput = function(param) {
    var data = param.data, value = param.value, minRows = param.minRows, maxRows = param.maxRows, onChange = param.onChange, disabled = param.disabled;
    var label = data.label, readOnly = data.readOnly, required = data.required;
    return /* @__PURE__ */ React7.createElement(EGDSTextArea, {
        label: label,
        readOnly: disabled || readOnly,
        required: required !== null && required !== void 0 ? required : false,
        value: value,
        minRows: minRows,
        maxRows: maxRows,
        onChange: onChange
    });
};
EGDSTextAreaInput.fragment = fragment3;
EGDSTextAreaInput.displayName = "EGDSTextAreaInput";
// ../internal/src/components/sheet/sheet-loader.tsx
import React8 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLoader } from "@egds/react-core/loader";
var SheetLoader = function(props) {
    return /* @__PURE__ */ React8.createElement(EGDSLayoutFlex, {
        justifyContent: "center",
        blockSize: "full_size"
    }, /* @__PURE__ */ React8.createElement(EGDSLayoutFlexItem, {
        alignSelf: "center"
    }, /* @__PURE__ */ React8.createElement(EGDSLoader, _object_spread({}, props))));
};
// src/utils/logger-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
    INTENT_BUTTON_CLICK: new SystemEvent(SystemEventLevel.INFO, "INTENT_BUTTON_CLICK_INFO"),
    SENDING_MESSAGE: new SystemEvent(SystemEventLevel.INFO, "SENDING_MESSAGE"),
    VAC_NOT_INITIALISED: new SystemEvent(SystemEventLevel.ERROR, "VAC_NOT_INITIALISED"),
    CONTACT_US_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "CONTACT_US_DATA_LOADING_ERROR")
};
// src/components/contact-us/__private/__fragments/back-button/back-button.tsx
import React9 from "react";
import { EGDSLink } from "@egds/react-core/link";
var BackButton = function(param) {
    var data = param.data, onClickHandler = param.onClickHandler;
    var back = data.back;
    return /* @__PURE__ */ React9.createElement(EGDSLink, {
        key: "back",
        onClick: onClickHandler
    }, /* @__PURE__ */ React9.createElement("button", {
        type: "button",
        key: "button"
    }, back));
};
BackButton.displayName = "BackButton";
// src/components/contact-us/__private/__fragments/contact-us-send-email-view.tsx
import React12, { useCallback, useEffect, useState } from "react";
import { gql as gql9, useMutation } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
// src/components/contact-us/__private/__fragments/send-email-response/contact-us-send-email-failed.tsx
import React10 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
var __fragment2 = gql7(_templateObject6(), HelpCenterEGDSButton.fragment);
var CARD_SPACING = {
    blockstart: "four"
};
var BUTTON_SPACING = {
    blockstart: "four"
};
var ContactUsSendEmailFailed = function(param) {
    var data = param.data, onClick = param.onClick, submitDisabled = param.submitDisabled;
    var title = data.title, message = data.message, icon = data.icon, button = data.button;
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(EGDSSpacing, {
        margin: CARD_SPACING
    }, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(EGDSBanner, {
        theme: "error"
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutFlex2, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React10.createElement(EGDSIcon2, {
        name: icon.id,
        spotlight: {
            theme: "standard"
        }
    })), /* @__PURE__ */ React10.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(EGDSHeading, {
        size: 7,
        tag: "h4"
    }, title), /* @__PURE__ */ React10.createElement(EGDSText, {
        size: 300
    }, message))))))), /* @__PURE__ */ React10.createElement(EGDSSpacing, {
        margin: BUTTON_SPACING
    }, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(HelpCenterEGDSButton, {
        data: button,
        onClickHandler: onClick,
        isDisabled: submitDisabled
    }))));
};
ContactUsSendEmailFailed.fragment = __fragment2;
ContactUsSendEmailFailed.displayName = "ContactUsSendEmailFailed";
// src/components/contact-us/__private/__fragments/send-email-response/contact-us-send-email-success.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText2 } from "@egds/react-core/text";
var __fragment3 = gql8(_templateObject7(), HelpCenterEGDSButton.fragment);
var BUTTON_SPACING2 = {
    blockstart: "four"
};
var ContactUsSendEmailSuccess = function(param) {
    var data = param.data, onClick = param.onClick;
    var title = data.title, message = data.message, icon = data.icon, button = data.button;
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(EGDSCard, {
        padded: true
    }, /* @__PURE__ */ React11.createElement(EGDSLayoutFlex3, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React11.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(EGDSIcon3, {
        name: icon.id,
        spotlight: "positive"
    }))), /* @__PURE__ */ React11.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(EGDSHeading2, {
        size: 7,
        tag: "h4"
    }, title), /* @__PURE__ */ React11.createElement(EGDSText2, {
        size: 300
    }, message))))), /* @__PURE__ */ React11.createElement(EGDSSpacing2, {
        margin: BUTTON_SPACING2
    }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(HelpCenterEGDSButton, {
        data: button,
        onClickHandler: onClick
    }))));
};
ContactUsSendEmailSuccess.fragment = __fragment3;
ContactUsSendEmailSuccess.displayName = "ContactUsSendEmailSuccess";
// src/components/contact-us/__private/__fragments/contact-us-send-email-view.tsx
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE = "Error while sending an email";
var SendEmailMutation = gql9(_templateObject8(), ContactUsSendEmailSuccess.fragment, ContactUsSendEmailFailed.fragment);
var SEND_BUTTON_SPACING = {
    blockstart: "four"
};
var ContactUsSendEmailView = function(props) {
    var _data_contactUsOptions;
    var _useState = _sliced_to_array(useState(false), 2), isButtonDisabled = _useState[0], setButtonDisabled = _useState[1];
    var onClose = props.onClose, sendButton = props.sendButton, request = props.request, disableForm = props.disableForm, isEmailAddressValid = props.isEmailAddressValid;
    var context = useBexApi().context;
    var logEvents = useLoggerEvents(EVENTS);
    var submitDisabled = isEmailAddressValid || isButtonDisabled || request.customerEmail === "" || request.customerName === "" || request.details === "";
    var _useMutation = _sliced_to_array(useMutation(SendEmailMutation), 2), sendEmail = _useMutation[0], _useMutation_ = _useMutation[1], data = _useMutation_.data, error = _useMutation_.error;
    useEffect(function() {
        var _data_contactUsOptions;
        setButtonDisabled(false);
        if ((data === null || data === void 0 ? void 0 : (_data_contactUsOptions = data.contactUsOptions) === null || _data_contactUsOptions === void 0 ? void 0 : _data_contactUsOptions.sendContactUsEmail.__typename) === "ContactUsSendEmailFailed") {
            disableForm(false);
        }
    }, [
        data
    ]);
    var clickSendEmail = useCallback(function() {
        setButtonDisabled(true);
        disableForm(true);
        sendEmail({
            variables: _object_spread({
                context: context
            }, request)
        });
    }, [
        sendEmail,
        context,
        request
    ]);
    if (error) {
        logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
            message: "".concat(CONTACT_US_DATA_LOADING_ERROR_MESSAGE, ": ").concat(error)
        });
        return null;
    }
    var responseView = data === null || data === void 0 ? void 0 : (_data_contactUsOptions = data.contactUsOptions) === null || _data_contactUsOptions === void 0 ? void 0 : _data_contactUsOptions.sendContactUsEmail;
    switch(responseView === null || responseView === void 0 ? void 0 : responseView.__typename){
        case "ContactUsSendEmailSuccess":
            return /* @__PURE__ */ React12.createElement(ContactUsSendEmailSuccess, {
                data: responseView,
                onClick: onClose
            });
        case "ContactUsSendEmailFailed":
            return /* @__PURE__ */ React12.createElement(ContactUsSendEmailFailed, {
                data: responseView,
                onClick: clickSendEmail,
                submitDisabled: submitDisabled
            });
        default:
            return /* @__PURE__ */ React12.createElement(EGDSSpacing3, {
                margin: SEND_BUTTON_SPACING
            }, /* @__PURE__ */ React12.createElement("div", null, /* @__PURE__ */ React12.createElement(HelpCenterEGDSButton, {
                data: sendButton,
                onClickHandler: clickSendEmail,
                isDisabled: submitDisabled
            })));
    }
};
ContactUsSendEmailView.displayName = "ContactUsSendEmailView";
// src/components/contact-us/__private/__fragments/heading.tsx
import React13 from "react";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSSubheading } from "@egds/react-core/text";
var HEADING_SPACING = {
    blockstart: "four"
};
var SUB_HEADING_SPACING = {
    blockstart: "six"
};
var Heading = function(props) {
    var heading = props.heading, subheading = props.subheading;
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(EGDSSpacing4, {
        margin: HEADING_SPACING
    }, /* @__PURE__ */ React13.createElement(EGDSHeading3, {
        tag: "h2",
        size: 3
    }, heading)), /* @__PURE__ */ React13.createElement(EGDSSpacing4, {
        margin: SUB_HEADING_SPACING
    }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(EGDSSubheading, {
        tag: "h3"
    }, subheading))));
};
// src/components/contact-us/__private/__fragments/contact-us-email-us-form-view.tsx
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE2 = "Error while loading email us form";
var EMAIL_FORM_SPACING = {
    blockstart: "four"
};
var __Query = gql10(_templateObject9(), ContactUsToolBar.fragment, HelpCenterEGDSTextInput.fragment, EGDSTextAreaInput.fragment, HelpCenterEGDSButton.fragment);
var ContactUsEmailUsFormView = function(props) {
    var onClose = props.onClose, onClickBack = props.onClickBack, product = props.product, intent = props.intent, skipSsr = props.skipSsr;
    var context = useBexApi2().context;
    var logEvents = useLoggerEvents2(EVENTS);
    var emailAddressValidationInfo = {
        validationPattern: "",
        errorMessage: ""
    };
    var _useState2 = _sliced_to_array(useState2(""), 2), customerName = _useState2[0], setCustomerName = _useState2[1];
    var _useState21 = _sliced_to_array(useState2({
        inputValue: "",
        errorMessage: "",
        isEmailValid: false
    }), 2), customerEmail = _useState21[0], setCustomerEmail = _useState21[1];
    var _useState22 = _sliced_to_array(useState2(""), 2), details = _useState22[0], setDetails = _useState22[1];
    var _useState23 = _sliced_to_array(useState2(false), 2), formDisabled = _useState23[0], setFormDisabled = _useState23[1];
    var validator = function(value, re) {
        return re && value.match(new RegExp(re));
    };
    var onChangeCustomerName = function(event) {
        setCustomerName(event.target.value);
    };
    var onChangeDetails = function(event) {
        setDetails(event.target.value);
    };
    var onChangeCustomerEmail = function(event) {
        var emailAddressValidationResult = !validator(event.target.value, emailAddressValidationInfo.validationPattern);
        setCustomerEmail({
            inputValue: event.target.value,
            errorMessage: emailAddressValidationResult ? emailAddressValidationInfo === null || emailAddressValidationInfo === void 0 ? void 0 : emailAddressValidationInfo.errorMessage : "",
            isEmailValid: emailAddressValidationResult
        });
    };
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        return /* @__PURE__ */ React14.createElement(EGDSSheetContent, null, /* @__PURE__ */ React14.createElement(SheetLoader, {
            isSmall: true
        }));
    }
    if (error || !data) {
        logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
            message: "".concat(CONTACT_US_DATA_LOADING_ERROR_MESSAGE2, ": ").concat(error)
        });
        return null;
    }
    var contactUsEmailFormView = data.contactUsOptions.contactUsEmailFormView;
    switch(contactUsEmailFormView.__typename){
        case "ContactUsEmailSheet":
            {
                var _contactUsEmailFormView_customerEmail_validations;
                var heading = contactUsEmailFormView.heading, subheading = contactUsEmailFormView.subheading, toolBar = contactUsEmailFormView.toolBar, send = contactUsEmailFormView.send;
                var emailAddressValidation = (_contactUsEmailFormView_customerEmail_validations = contactUsEmailFormView.customerEmail.validations) === null || _contactUsEmailFormView_customerEmail_validations === void 0 ? void 0 : _contactUsEmailFormView_customerEmail_validations[0];
                var validationPattern = (emailAddressValidation === null || emailAddressValidation === void 0 ? void 0 : emailAddressValidation.__typename) === "EGDSRegexInputValidation" ? emailAddressValidation.pattern : void 0;
                emailAddressValidationInfo.validationPattern = validationPattern;
                emailAddressValidationInfo.errorMessage = emailAddressValidation === null || emailAddressValidation === void 0 ? void 0 : emailAddressValidation.errorMessage;
                return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(ContactUsToolBar, {
                    close: onClose,
                    data: toolBar
                }), /* @__PURE__ */ React14.createElement(EGDSSheetContent, null, /* @__PURE__ */ React14.createElement(BackButton, {
                    data: contactUsEmailFormView,
                    onClickHandler: onClickBack
                }), /* @__PURE__ */ React14.createElement(Heading, {
                    heading: heading,
                    subheading: subheading
                }), /* @__PURE__ */ React14.createElement(EGDSForm, {
                    hasRequiredFieldIndicator: true
                }, /* @__PURE__ */ React14.createElement(EGDSSpacing5, {
                    margin: EMAIL_FORM_SPACING
                }, /* @__PURE__ */ React14.createElement(EGDSLayoutFlex4, {
                    space: "four",
                    direction: "column"
                }, /* @__PURE__ */ React14.createElement(HelpCenterEGDSTextInput, {
                    data: contactUsEmailFormView.customerName,
                    value: customerName,
                    onChange: onChangeCustomerName,
                    disabled: formDisabled
                }), /* @__PURE__ */ React14.createElement(HelpCenterEGDSTextInput, {
                    data: contactUsEmailFormView.customerEmail,
                    value: customerEmail.inputValue,
                    invalid: customerEmail.errorMessage,
                    onChange: onChangeCustomerEmail,
                    disabled: formDisabled
                }), /* @__PURE__ */ React14.createElement(EGDSTextAreaInput, {
                    data: contactUsEmailFormView.details,
                    value: details,
                    onChange: onChangeDetails,
                    minRows: 3,
                    disabled: formDisabled
                })))), /* @__PURE__ */ React14.createElement(ContactUsSendEmailView, {
                    sendButton: send,
                    request: {
                        customerName: customerName,
                        customerEmail: customerEmail.inputValue,
                        product: product,
                        intent: intent,
                        details: details
                    },
                    onClose: onClose,
                    disableForm: setFormDisabled,
                    isEmailAddressValid: customerEmail.isEmailValid
                }), /* @__PURE__ */ React14.createElement(EGDSSpacingHr, {
                    blockMargin: "six"
                })));
            }
        default:
            return null;
    }
};
ContactUsEmailUsFormView.displayName = "ContactUsEmailUsFormView";
// src/components/contact-us/__private/__fragments/contact-us-options-view.tsx
import React17 from "react";
import { gql as gql13, useQuery as useQuery2 } from "@apollo/client";
import { EGDSActionList } from "@egds/react-core/action-list-item";
import { EGDSSheetContent as EGDSSheetContent3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing7, EGDSSpacingHr as EGDSSpacingHr3 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents4 } from "@shared-ui/logger-context";
// src/components/contact-us/__private/__fragments/contact-us-error-view.tsx
import React15 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSBanner as EGDSBanner2 } from "@egds/react-core/banner";
import { EGDSIcon as EGDSIcon4 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent as EGDSSheetContent2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing6, EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4, EGDSText as EGDSText3 } from "@egds/react-core/text";
var ERROR_VIEW_SPACING = {
    blockstart: "four"
};
var fragment4 = gql11(_templateObject10());
var ContactUsErrorView = function(props) {
    var data = props.data, onClose = props.onClose;
    var _data_subHeadingText;
    return /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(ContactUsToolBar, {
        close: onClose,
        data: data.toolBar
    }), /* @__PURE__ */ React15.createElement(EGDSSheetContent2, null, /* @__PURE__ */ React15.createElement(Heading, {
        heading: data.heading,
        subheading: (_data_subHeadingText = data.subHeadingText) !== null && _data_subHeadingText !== void 0 ? _data_subHeadingText : ""
    }), /* @__PURE__ */ React15.createElement(EGDSSpacing6, {
        margin: ERROR_VIEW_SPACING
    }, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(EGDSBanner2, {
        theme: "error"
    }, /* @__PURE__ */ React15.createElement(EGDSLayoutFlex5, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React15.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(EGDSIcon4, {
        name: data.icon.id,
        spotlight: {
            theme: "standard",
            background: false
        }
    }))), /* @__PURE__ */ React15.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(EGDSHeading4, {
        size: 7,
        tag: "h4"
    }, data.errorTitle), /* @__PURE__ */ React15.createElement(EGDSText3, null, data.errorMessage))))))), /* @__PURE__ */ React15.createElement(EGDSSpacingHr2, {
        blockMargin: "six"
    })));
};
ContactUsErrorView.fragment = fragment4;
ContactUsErrorView.displayName = "ContactUsErrorView";
// src/components/contact-us/__private/__fragments/contact-us-option.tsx
import React16 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSActionListItem, EGDSActionListItemLink } from "@egds/react-core/action-list-item";
import { EGDSIcon as EGDSIcon5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
import { useVirtualAgentContext } from "@shared-ui/retail-help-center-util";
import { ViewMedium, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var fragment5 = gql12(_templateObject11());
var ContactUsOption = function(props) {
    var data = props.data, onNavigate = props.onNavigate, onClose = props.onClose;
    var logEvents = useLoggerEvents3(EVENTS);
    var controller = useVirtualAgentContext().controller;
    var initiateVacMessage = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                logEvents.INTENT_BUTTON_CLICK.log({
                    message: "calling sendMessage for ".concat(data.optionLabel)
                });
                onClose();
                controller.sendMessage({
                    messageType: "POSTBACK",
                    text: data.optionLabel,
                    intent: "AGENT_CONNECT_REQUEST"
                });
                return [
                    2
                ];
            });
        });
        return function initiateVacMessage() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderView = React16.useCallback(function() {
        switch(data.option){
            case "CHAT_WITH_AGENT":
            case "CHAT_BACK_WITH_AGENT":
            case "CALL_BACK_WITH_AGENT":
                return /* @__PURE__ */ React16.createElement(Viewport2, null, /* @__PURE__ */ React16.createElement(ViewSmall2, null, /* @__PURE__ */ React16.createElement(EGDSActionListItemLink, null, /* @__PURE__ */ React16.createElement("button", {
                    type: "button",
                    onClick: initiateVacMessage
                }, data.optionLabel))), /* @__PURE__ */ React16.createElement(ViewMedium, null, /* @__PURE__ */ React16.createElement(EGDSActionListItemLink, null, /* @__PURE__ */ React16.createElement("button", {
                    type: "button",
                    onClick: initiateVacMessage
                }, data.optionLabel))));
            default:
                return /* @__PURE__ */ React16.createElement(EGDSActionListItemLink, null, /* @__PURE__ */ React16.createElement("button", {
                    type: "button",
                    onClick: function() {
                        return onNavigate(data.option);
                    }
                }, data.optionLabel));
        }
    }, [
        data.option,
        data.optionLabel,
        logEvents,
        onNavigate
    ]);
    return /* @__PURE__ */ React16.createElement(EGDSActionListItem, {
        key: data.optionLabel
    }, renderView(), /* @__PURE__ */ React16.createElement(EGDSLayoutFlex6, {
        space: "three"
    }, /* @__PURE__ */ React16.createElement(EGDSLayoutFlexItem5, {
        shrink: 0,
        alignSelf: "center"
    }, /* @__PURE__ */ React16.createElement(EGDSIcon5, {
        name: data.leftIcon.id
    })), /* @__PURE__ */ React16.createElement(EGDSLayoutFlexItem5, {
        grow: 1
    }, /* @__PURE__ */ React16.createElement("section", null, /* @__PURE__ */ React16.createElement(EGDSText4, {
        size: 400,
        weight: "bold"
    }, data.optionLabel), /* @__PURE__ */ React16.createElement(EGDSText4, {
        size: 200,
        theme: "standard"
    }, data.waitTime))), /* @__PURE__ */ React16.createElement(EGDSLayoutFlexItem5, {
        alignSelf: "center"
    }, /* @__PURE__ */ React16.createElement(EGDSIcon5, {
        name: data.rightIcon.id
    }))));
};
ContactUsOption.fragment = fragment5;
ContactUsOption.displayName = "ContactUsOption";
// src/components/contact-us/__private/__fragments/contact-us-options-view.tsx
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE3 = "Error while loading contact options";
var ACTION_LIST_SPACING = {
    blockstart: "four"
};
var __Query2 = gql13(_templateObject12(), ContactUsToolBar.fragment, ContactUsOption.fragment, ContactUsErrorView.fragment);
var ContactUsOptionsView = function(props) {
    var onClose = props.onClose, skipSsr = props.skipSsr, inputs = props.inputs, onNavigate = props.onNavigate;
    var context = useBexApi3().context;
    var logEvents = useLoggerEvents4(EVENTS);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (loading) {
        return /* @__PURE__ */ React17.createElement(EGDSSheetContent3, null, /* @__PURE__ */ React17.createElement(SheetLoader, {
            isSmall: true
        }));
    }
    if (error || !data) {
        logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
            message: "".concat(CONTACT_US_DATA_LOADING_ERROR_MESSAGE3, ": ").concat(error)
        });
        return null;
    }
    var contactUsOptionsView = data.contactUsOptions.contactUsOptionsView;
    switch(contactUsOptionsView.__typename){
        case "ContactOptionsSheet":
            {
                var options = contactUsOptionsView.options, heading = contactUsOptionsView.heading, subheading = contactUsOptionsView.subheading, toolBar = contactUsOptionsView.toolBar;
                return /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(ContactUsToolBar, {
                    close: onClose,
                    data: toolBar
                }), /* @__PURE__ */ React17.createElement(EGDSSheetContent3, null, /* @__PURE__ */ React17.createElement(Heading, {
                    heading: heading,
                    subheading: subheading
                }), /* @__PURE__ */ React17.createElement(EGDSSpacing7, {
                    margin: ACTION_LIST_SPACING
                }, /* @__PURE__ */ React17.createElement(EGDSActionList, null, options.map(function(option) {
                    return /* @__PURE__ */ React17.createElement(ContactUsOption, {
                        key: option.optionLabel,
                        onNavigate: onNavigate,
                        data: option,
                        onClose: onClose
                    });
                }))), /* @__PURE__ */ React17.createElement(EGDSSpacingHr3, {
                    blockMargin: "six"
                })));
            }
        case "ContactUsErrorView":
            {
                return /* @__PURE__ */ React17.createElement(ContactUsErrorView, {
                    onClose: onClose,
                    data: contactUsOptionsView
                });
            }
    }
};
ContactUsOptionsView.displayName = "ContactUsOptionsView";
// src/components/contact-us/__private/__fragments/contact-us-sheet-view.tsx
import React20, { useCallback as useCallback2, useEffect as useEffect3, useState as useState3 } from "react";
import { gql as gql16, useQuery as useQuery3 } from "@apollo/client";
import { EGDSForm as EGDSForm2 } from "@egds/react-core/form";
import { EGDSLayoutFlex as EGDSLayoutFlex7 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent as EGDSSheetContent4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing8, EGDSSpacingHr as EGDSSpacingHr4 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents5 } from "@shared-ui/logger-context";
// ../internal/src/components/egds-select/egds-select.tsx
import React19 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSSelect } from "@egds/react-core/input";
// ../internal/src/components/egds-select/egds-basic-option.tsx
import React18 from "react";
import { gql as gql14 } from "@apollo/client";
var __Fragment = gql14(_templateObject13());
var EGDSBasicOption = function(param) {
    var data = param.data;
    var _data_selected;
    return /* @__PURE__ */ React18.createElement("option", {
        key: data.value,
        value: data.value,
        "aria-selected": (_data_selected = data.selected) !== null && _data_selected !== void 0 ? _data_selected : false
    }, data.label);
};
EGDSBasicOption.displayName = "EGDSBasicOption";
EGDSBasicOption.fragment = __Fragment;
// ../internal/src/components/egds-select/egds-select.tsx
var __Fragment2 = gql15(_templateObject14(), EGDSBasicOption.fragment);
var HelpCenterEGDSSelect = function(param) {
    var emptyState = param.emptyState, value = param.value, onChange = param.onChange, data = param.data, required = param.required;
    var label = data.label, egdsElementId = data.egdsElementId, options = data.options, readOnly = data.readOnly;
    if (!egdsElementId || options.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React19.createElement(EGDSSelect, {
        readOnly: readOnly,
        value: value,
        label: label,
        id: egdsElementId,
        onChange: onChange,
        emptyState: emptyState,
        required: required
    }, options.map(function(optionItem, index) {
        return optionItem.__typename === "EGDSBasicOption" && /* @__PURE__ */ React19.createElement(EGDSBasicOption, {
            key: "option-".concat(index),
            data: optionItem
        });
    }));
};
HelpCenterEGDSSelect.displayName = "HelpCenterEGDSSelect";
HelpCenterEGDSSelect.fragment = __Fragment2;
// src/components/contact-us/__private/__fragments/contact-us-sheet-view.tsx
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE4 = "Error while loading contact form details";
var CUSTOMER_FORM_SPACING = {
    blockstart: "four"
};
var SUBMIT_BUTTON_SPACING = {
    blockstart: "four"
};
var __Query3 = gql16(_templateObject15(), ContactUsToolBar.fragment, HelpCenterEGDSTextInput.fragment, HelpCenterEGDSButton.fragment, HelpCenterEGDSSelect.fragment);
var ContactUsSheetView = function(props) {
    var onClose = props.onClose, onSubmitDetails = props.onSubmitDetails, formInputs = props.formInputs, skipSsr = props.skipSsr;
    var context = useBexApi4().context;
    var logEvents = useLoggerEvents5(EVENTS);
    var _formInputs_phoneNumber;
    var _useState3 = _sliced_to_array(useState3({
        inputValue: (_formInputs_phoneNumber = formInputs === null || formInputs === void 0 ? void 0 : formInputs.phoneNumber) !== null && _formInputs_phoneNumber !== void 0 ? _formInputs_phoneNumber : "",
        errorMessage: ""
    }), 2), phoneNumber = _useState3[0], setPhoneNumber = _useState3[1];
    var _formInputs_itineraryNumber;
    var _useState31 = _sliced_to_array(useState3({
        inputValue: (_formInputs_itineraryNumber = formInputs === null || formInputs === void 0 ? void 0 : formInputs.itineraryNumber) !== null && _formInputs_itineraryNumber !== void 0 ? _formInputs_itineraryNumber : "",
        errorMessage: ""
    }), 2), itineraryNumber = _useState31[0], setItineraryNumber = _useState31[1];
    var _useState32 = _sliced_to_array(useState3(""), 2), category = _useState32[0], setCategory = _useState32[1];
    var _useState33 = _sliced_to_array(useState3(""), 2), intent = _useState33[0], setIntent = _useState33[1];
    var clickSeeOptions = useCallback2(function() {
        onSubmitDetails({
            phoneNumber: phoneNumber.inputValue,
            itineraryNumber: itineraryNumber.inputValue,
            category: category,
            intent: intent
        });
    }, [
        onSubmitDetails,
        phoneNumber,
        itineraryNumber,
        category,
        intent
    ]);
    var _formInputs_category, _formInputs_intent;
    var variables = {
        context: context,
        articleProduct: (_formInputs_category = formInputs === null || formInputs === void 0 ? void 0 : formInputs.category) !== null && _formInputs_category !== void 0 ? _formInputs_category : null,
        articleIntent: (_formInputs_intent = formInputs === null || formInputs === void 0 ? void 0 : formInputs.intent) !== null && _formInputs_intent !== void 0 ? _formInputs_intent : null
    };
    var _useQuery3 = useQuery3(__Query3, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading;
    var getSelectedOption = function(options) {
        var option = options.find(function(opt) {
            return opt.__typename === "EGDSBasicOption" && opt.selected;
        });
        return (option === null || option === void 0 ? void 0 : option.__typename) === "EGDSBasicOption" ? option.value : "";
    };
    useEffect3(function() {
        var _data_contactUsOptions_contactUsSheetViewWithPayload, _data_contactUsOptions;
        if ((data === null || data === void 0 ? void 0 : (_data_contactUsOptions = data.contactUsOptions) === null || _data_contactUsOptions === void 0 ? void 0 : (_data_contactUsOptions_contactUsSheetViewWithPayload = _data_contactUsOptions.contactUsSheetViewWithPayload) === null || _data_contactUsOptions_contactUsSheetViewWithPayload === void 0 ? void 0 : _data_contactUsOptions_contactUsSheetViewWithPayload.__typename) === "ContactUsSheet" && formInputs != null) {
            var _data_contactUsOptions_contactUsSheetViewWithPayload_customerFormContent = data.contactUsOptions.contactUsSheetViewWithPayload.customerFormContent, categorySelect = _data_contactUsOptions_contactUsSheetViewWithPayload_customerFormContent.categorySelect, intentSelect = _data_contactUsOptions_contactUsSheetViewWithPayload_customerFormContent.intentSelect;
            setCategory(getSelectedOption(categorySelect.options));
            setIntent(getSelectedOption(intentSelect.options));
        }
    }, [
        data,
        formInputs
    ]);
    if (loading) {
        return /* @__PURE__ */ React20.createElement(EGDSSheetContent4, null, /* @__PURE__ */ React20.createElement(SheetLoader, {
            isSmall: true
        }));
    }
    if (error || !data) {
        logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
            message: "".concat(CONTACT_US_DATA_LOADING_ERROR_MESSAGE4, ": ").concat(error)
        });
        return null;
    }
    var validator = function(value, re) {
        return re && value.match(new RegExp(re));
    };
    var onChangePhoneNumber = function(errorMessage) {
        return function(event) {
            setPhoneNumber({
                inputValue: event.target.value,
                errorMessage: event.target.validationMessage && errorMessage
            });
        };
    };
    var onChangeItineraryNumber = function(errorMessage) {
        return function(event) {
            setItineraryNumber({
                inputValue: event.target.value,
                errorMessage: event.target.validationMessage && errorMessage
            });
        };
    };
    var onChangeCategory = function(event) {
        setCategory(event.target.value);
    };
    var onChangeIntent = function(event) {
        setIntent(event.target.value);
    };
    var contactUsSheetViewWithPayload = data.contactUsOptions.contactUsSheetViewWithPayload;
    switch(contactUsSheetViewWithPayload.__typename){
        case "ContactUsSheet":
            {
                var _customerFormContent_phoneNumber_validations, _customerFormContent_itineraryNumber_validations, _customerFormContent_itineraryNumber_validations1;
                var customerFormContent = contactUsSheetViewWithPayload.customerFormContent, heading = contactUsSheetViewWithPayload.heading, subheading = contactUsSheetViewWithPayload.subheading, toolBar = contactUsSheetViewWithPayload.toolBar, seeContactUsOptions = contactUsSheetViewWithPayload.seeContactUsOptions;
                var phoneNumberValidation = (_customerFormContent_phoneNumber_validations = customerFormContent.phoneNumber.validations) === null || _customerFormContent_phoneNumber_validations === void 0 ? void 0 : _customerFormContent_phoneNumber_validations[0];
                var phoneNumberPattern = (phoneNumberValidation === null || phoneNumberValidation === void 0 ? void 0 : phoneNumberValidation.__typename) === "EGDSRegexInputValidation" ? phoneNumberValidation.pattern : void 0;
                var phoneNumberErrorMessage = phoneNumberValidation === null || phoneNumberValidation === void 0 ? void 0 : phoneNumberValidation.errorMessage;
                var itineraryNumberValidation = (_customerFormContent_itineraryNumber_validations = customerFormContent.itineraryNumber.validations) === null || _customerFormContent_itineraryNumber_validations === void 0 ? void 0 : _customerFormContent_itineraryNumber_validations[0];
                var itineraryNumberPattern = (itineraryNumberValidation === null || itineraryNumberValidation === void 0 ? void 0 : itineraryNumberValidation.__typename) === "EGDSRegexInputValidation" ? itineraryNumberValidation.pattern : void 0;
                var itineraryNumberErrorMessage = (_customerFormContent_itineraryNumber_validations1 = customerFormContent.itineraryNumber.validations) === null || _customerFormContent_itineraryNumber_validations1 === void 0 ? void 0 : _customerFormContent_itineraryNumber_validations1[0].errorMessage;
                var submitDisabled = !validator(phoneNumber.inputValue, phoneNumberPattern) || customerFormContent.itineraryNumber.required && itineraryNumber.inputValue !== "" && !validator(itineraryNumber.inputValue, itineraryNumberPattern) || intent === "" || category === "";
                return /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement(ContactUsToolBar, {
                    close: onClose,
                    data: toolBar
                }), /* @__PURE__ */ React20.createElement(EGDSSheetContent4, null, /* @__PURE__ */ React20.createElement(Heading, {
                    heading: heading,
                    subheading: subheading
                }), /* @__PURE__ */ React20.createElement(EGDSForm2, {
                    hasRequiredFieldIndicator: true,
                    onSubmit: clickSeeOptions
                }, /* @__PURE__ */ React20.createElement(EGDSSpacing8, {
                    margin: CUSTOMER_FORM_SPACING
                }, /* @__PURE__ */ React20.createElement(EGDSLayoutFlex7, {
                    space: "four",
                    direction: "column"
                }, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(HelpCenterEGDSTextInput, {
                    data: customerFormContent.phoneNumber,
                    value: phoneNumber.inputValue,
                    onChange: onChangePhoneNumber(phoneNumberErrorMessage),
                    invalid: phoneNumber.errorMessage,
                    pattern: phoneNumberPattern
                })), /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(HelpCenterEGDSTextInput, {
                    data: customerFormContent.itineraryNumber,
                    value: itineraryNumber.inputValue,
                    onChange: onChangeItineraryNumber(itineraryNumberErrorMessage),
                    invalid: itineraryNumber.errorMessage,
                    pattern: itineraryNumberPattern
                })), /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(HelpCenterEGDSSelect, {
                    data: customerFormContent.categorySelect,
                    value: category,
                    emptyState: true,
                    onChange: onChangeCategory,
                    required: true
                })), /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(HelpCenterEGDSSelect, {
                    data: customerFormContent.intentSelect,
                    value: intent,
                    emptyState: true,
                    onChange: onChangeIntent,
                    required: true
                })))), /* @__PURE__ */ React20.createElement(EGDSSpacing8, {
                    margin: SUBMIT_BUTTON_SPACING
                }, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(HelpCenterEGDSButton, {
                    data: seeContactUsOptions,
                    type: "submit",
                    isDisabled: submitDisabled
                })))), /* @__PURE__ */ React20.createElement(EGDSSpacingHr4, {
                    blockMargin: "six"
                })));
            }
        default:
            return null;
    }
};
ContactUsSheetView.displayName = "ContactUsSheetView";
// src/components/contact-us/__private/__fragments/speak-to-next-available-agent-view.tsx
import React22 from "react";
import { gql as gql18, useQuery as useQuery4 } from "@apollo/client";
import { EGDSList } from "@egds/react-core/list";
import { EGDSSheetContent as EGDSSheetContent5 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents6 } from "@shared-ui/logger-context";
// src/components/contact-us/__private/__fragments/phone-number-data.tsx
import React21, { useMemo } from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSListItem } from "@egds/react-core/list";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var __fragment4 = gql17(_templateObject16(), HelpCenterEGDSButton.fragment);
var PhoneNumberData = function(props) {
    var data = props.data;
    var callNumber = function() {
        window.open("tel:".concat(data.phoneNumber));
    };
    var label = useMemo(function() {
        return /* @__PURE__ */ React21.createElement(EGDSText5, {
            size: 400,
            theme: "standard"
        }, data.region && /* @__PURE__ */ React21.createElement(EGDSText5, {
            size: 400,
            theme: "standard",
            inline: "strong"
        }, data.region), data.phoneType);
    }, [
        data.region,
        data.phoneType
    ]);
    var _data_call_accessibility, _data_call_accessibility1;
    return /* @__PURE__ */ React21.createElement(Viewport3, null, /* @__PURE__ */ React21.createElement(ViewSmall3, null, /* @__PURE__ */ React21.createElement(EGDSListItem, {
        key: data.phoneType
    }, /* @__PURE__ */ React21.createElement(EGDSLayoutFlex8, {
        space: "three",
        alignItems: "center"
    }, /* @__PURE__ */ React21.createElement(EGDSLayoutFlexItem6, {
        grow: 1
    }, label), /* @__PURE__ */ React21.createElement(EGDSLayoutFlexItem6, {
        shrink: 0
    }, /* @__PURE__ */ React21.createElement(EGDSText5, {
        size: 400,
        weight: "bold"
    }, data.phoneNumber)), data.call && /* @__PURE__ */ React21.createElement(EGDSLayoutFlexItem6, {
        shrink: 0
    }, /* @__PURE__ */ React21.createElement(Experiment, {
        name: "ContactUsTelephoneLink"
    }, /* @__PURE__ */ React21.createElement(ExperimentControl, null, /* @__PURE__ */ React21.createElement(EGDSPrimaryButton2, {
        type: "button",
        onClick: callNumber,
        title: (_data_call_accessibility = data.call.accessibility) !== null && _data_call_accessibility !== void 0 ? _data_call_accessibility : ""
    }, data.call.primary)), /* @__PURE__ */ React21.createElement(ExperimentVariant, {
        bucket: 1
    }, /* @__PURE__ */ React21.createElement(EGDSPrimaryButton2, {
        tag: "a",
        href: "tel:".concat(data.phoneNumber),
        title: (_data_call_accessibility1 = data.call.accessibility) !== null && _data_call_accessibility1 !== void 0 ? _data_call_accessibility1 : ""
    }, data.call.primary))))))), /* @__PURE__ */ React21.createElement(ViewMedium2, null, /* @__PURE__ */ React21.createElement(EGDSListItem, {
        key: data.phoneType
    }, /* @__PURE__ */ React21.createElement(EGDSLayoutFlex8, {
        space: "two"
    }, /* @__PURE__ */ React21.createElement(EGDSLayoutFlexItem6, {
        grow: 1,
        alignSelf: "start"
    }, label), /* @__PURE__ */ React21.createElement(EGDSLayoutFlexItem6, {
        alignSelf: "end"
    }, /* @__PURE__ */ React21.createElement(EGDSText5, {
        size: 400,
        weight: "bold"
    }, data.phoneNumber))))));
};
PhoneNumberData.fragment = __fragment4;
PhoneNumberData.displayName = "ContactUsPhoneNumber";
// src/components/contact-us/__private/__fragments/speak-to-next-available-agent-view.tsx
var SpeakNextAvailableAgentQuery = gql18(_templateObject17(), ContactUsToolBar.fragment, PhoneNumberData.fragment, ContactUsErrorView.fragment);
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE5 = "Error while loading available agent details";
var PHONE_NUMBER_LIST_SPACING = {
    block: "four"
};
var SpeakToNextAvailableAgentView = function(props) {
    var onClose = props.onClose, onClickBackDetails = props.onClickBackDetails, skipSsr = props.skipSsr, inputs = props.inputs;
    var context = useBexApi5().context;
    var logEvents = useLoggerEvents6(EVENTS);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery4 = useQuery4(SpeakNextAvailableAgentQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery4.data, error = _useQuery4.error, loading = _useQuery4.loading;
    if (loading) {
        return /* @__PURE__ */ React22.createElement(EGDSSheetContent5, null, /* @__PURE__ */ React22.createElement(SheetLoader, {
            isSmall: true
        }));
    }
    if (error || !data) {
        logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
            message: "".concat(CONTACT_US_DATA_LOADING_ERROR_MESSAGE5, ": ").concat(error)
        });
        return null;
    }
    var speakNextAvailableAgentSheetView = data.contactUsOptions.speakNextAvailableAgentSheetView;
    switch(speakNextAvailableAgentSheetView.__typename){
        case "SpeakNextAvailableAgentSheet":
            {
                var toolBar = speakNextAvailableAgentSheetView.toolBar, heading = speakNextAvailableAgentSheetView.heading, subheading = speakNextAvailableAgentSheetView.subheading, phoneNumberList = speakNextAvailableAgentSheetView.phoneNumberList;
                return /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(ContactUsToolBar, {
                    close: onClose,
                    data: toolBar
                }), /* @__PURE__ */ React22.createElement(EGDSSheetContent5, null, /* @__PURE__ */ React22.createElement(BackButton, {
                    data: speakNextAvailableAgentSheetView,
                    onClickHandler: onClickBackDetails
                }), /* @__PURE__ */ React22.createElement(Heading, {
                    heading: heading,
                    subheading: subheading
                }), /* @__PURE__ */ React22.createElement(EGDSSpacing9, {
                    margin: PHONE_NUMBER_LIST_SPACING
                }, /* @__PURE__ */ React22.createElement(EGDSList, {
                    bullet: "no-bullet"
                }, phoneNumberList.map(function(phoneNumber) {
                    return /* @__PURE__ */ React22.createElement(PhoneNumberData, {
                        key: phoneNumber.phoneType,
                        data: phoneNumber
                    });
                })))));
            }
        case "ContactUsErrorView":
            {
                return /* @__PURE__ */ React22.createElement(ContactUsErrorView, {
                    onClose: onClose,
                    data: speakNextAvailableAgentSheetView
                });
            }
    }
};
SpeakToNextAvailableAgentView.displayName = "SpeakToNextAvailableAgentView";
// src/components/contact-us/contact-us-form.tsx
var ContactUsForm = function(props) {
    var isVisible = props.isVisible, onClose = props.onClose, formInputs = props.formInputs;
    var _useState4 = _sliced_to_array(useState4("ContactUsSheetView"), 2), view = _useState4[0], setView = _useState4[1];
    var _useState41 = _sliced_to_array(useState4({
        phoneNumber: "",
        category: "",
        intent: "",
        itineraryNumber: ""
    }), 2), customerFormContent = _useState41[0], setCustomerFormContent = _useState41[1];
    var onSubmitDetails = function(searchFormInput) {
        setCustomerFormContent(searchFormInput);
        setView("ContactUsOptionsView");
    };
    var onClickBack = function() {
        setView("ContactUsOptionsView");
    };
    var onNavigate = function(option) {
        switch(option){
            case "SEND_EMAIL_AGENT":
                setView("ContactUsEmailUsFormView");
                break;
            case "CALL_TO_AGENT":
                setView("SpeakToNextAvailableAgentView");
                break;
        }
    };
    var renderView = useCallback3(function() {
        switch(view){
            case "ContactUsSheetView":
                return /* @__PURE__ */ React23.createElement(ContactUsSheetView, {
                    inputs: {},
                    formInputs: formInputs,
                    onClose: onClose,
                    onSubmitDetails: onSubmitDetails
                });
            case "ContactUsOptionsView":
                return /* @__PURE__ */ React23.createElement(ContactUsOptionsView, {
                    inputs: customerFormContent,
                    onClose: onClose,
                    onNavigate: onNavigate
                });
            case "SpeakToNextAvailableAgentView":
                return /* @__PURE__ */ React23.createElement(SpeakToNextAvailableAgentView, {
                    inputs: {
                        category: customerFormContent.category,
                        intent: customerFormContent.intent
                    },
                    onClose: onClose,
                    onClickBackDetails: onClickBack
                });
            case "ContactUsEmailUsFormView":
                return /* @__PURE__ */ React23.createElement(ContactUsEmailUsFormView, {
                    inputs: {},
                    product: customerFormContent.category,
                    intent: customerFormContent.intent,
                    onClose: onClose,
                    onClickBack: onClickBack
                });
        }
    }, [
        view,
        onClose,
        formInputs,
        customerFormContent
    ]);
    return /* @__PURE__ */ React23.createElement(SheetViewPort, {
        isVisible: isVisible,
        triggerRef: null
    }, /* @__PURE__ */ React23.createElement("div", {
        "data-stid": "contactUs-dialog"
    }, renderView()));
};
ContactUsForm.displayName = "sharedui-ContactUsForm";
export { ContactUsForm };
//# sourceMappingURL=index.js.map